import {
    IBaseExtensionCallBackAdapter,
    IBaseExtensionService,
} from '@src/slide/application/service/edit-extension/core/base/interface';
import {
    IDocInfoExtendService,
} from '@src/slide/application/no-edit/service/doc-extend-service/doc-extend-service.interface';
import { DocExtendService } from '@src/slide/application/no-edit/service/doc-extend-service';
import { NoEditService } from '@src/slide/application/no-edit/service/no-edit-service';
import {
    INoEditService,
    PluginConfig,
} from '@src/slide/application/no-edit/service/no-edit-service/no-edit-service.interface';
import { ILoginPlugin, LOGIN_PLUGIN_NAME } from '@src/slide/application/no-edit/plugins/login/login-plugin.interface';
import {
    DocInfoExtendEventsKeys,
} from '@src/slide/application/no-edit/service/doc-extend-service/doc-extend-service-events.interface';
import { LOGIN_PLUGIN_CONFIG } from '@src/slide/application/no-edit/plugins/login/plugin-config';

/**
 * 非编模块集合。依赖编辑器暴露的能力
 */
export default class BaseNoEditModules {
    // 编辑器对外暴露的能力
    protected extensionService: IBaseExtensionService;
    // 非编提供给编辑器的文档信息服务
    protected docInfoService?: IDocInfoExtendService;
    // 负责管理所有非编的plugin
    protected noEditService: INoEditService;

    /**
     * 非编初始化依赖编辑器对外暴露的服务
     * @param extensionService
     */
    public init(extensionService: IBaseExtensionService): void {
        this.extensionService = extensionService;

        this.docInfoService = new DocExtendService();
        // 初始化编辑层需要的docService
        extensionService.setDocInfo(this.docInfoService);

        this.initNoEditService();
        this.setSetLifecycleAdapter();
        this.setNoEditCallbackAdapter();
    }

    /**
     * 获取要注册的Plugins。
     * 子类可重写
     */
    protected getRegisterPlugins(): PluginConfig[] {
        return [
            LOGIN_PLUGIN_CONFIG,
        ];
    }

    // 编辑器生命周期回调
    protected onReady() {
        // 子类重写
    }
    // 编辑器生命周期回调
    protected onInfrastructureDidReady() {
        this.initLoginPlugin();
    }
    // 编辑器生命周期回调
    protected onFirstSlideRender() {
        // 子类重写
    }

    /**
     * 获取实现的callback回调
     * @protected
     */
    protected getCallbackAdapter(): IBaseExtensionCallBackAdapter {
        return {
            isLogin: () => {
                const loginPlugin = this.getLoginPlugin();
                return loginPlugin?.isLogin() || false;
            },
            logout: () => {
                const loginPlugin = this.getLoginPlugin();
                loginPlugin?.logout();
            },
            login: async () => {
                const loginPlugin = this.getLoginPlugin();
                return await loginPlugin?.login();
            },
            getUid: (): string => {
                const loginPlugin = this.getLoginPlugin();
                return loginPlugin?.getUid() || '';
            },
            getUidKey: (): string => {
                const loginPlugin = this.getLoginPlugin();
                return loginPlugin?.getUidKey() || '';
            },
        };
    }

    private getLoginPlugin(): ILoginPlugin | undefined {
        return this.noEditService.getPluginSync<ILoginPlugin>(LOGIN_PLUGIN_NAME);
    }

    /**
     * 初始化非编辑模块Service
     */
    private initNoEditService(): void {
        this.noEditService = new NoEditService({
            extensionService: this.extensionService,
        });
        // 注册非编辑plugin
        this.noEditService.batchRegisterPlugins(this.getRegisterPlugins());
    }

    /**
     * 注册编辑器生命周期的回调Adapter
     */
    private setSetLifecycleAdapter() {
        this.extensionService.setLifecycleAdapter({
            onReady: () => {
                this.onReady();
            },
            onInfrastructureDidReady: () => {
                this.onInfrastructureDidReady();
            },
            onFirstSlideRender: () => {
                this.onFirstSlideRender();
            },
        });
    }

    /**
     * 注册非编辑入口事件回调Adapter
     */
    private setNoEditCallbackAdapter() {
        this.extensionService.setCallBackAdapter(this.getCallbackAdapter());
    }

    /**
     * 初始化登录plugin
     */
    private initLoginPlugin(): void {
        const loginPlugin = this.getLoginPlugin();
        loginPlugin?.onUserReady((data) => {
            if (!this.docInfoService) return;
            this.docInfoService.userInfo = data; // 保存user info
            this.docInfoService.event.emit(DocInfoExtendEventsKeys.USER_INFO_READY_EVENT, data);
        });
    }
}
